import { getPasskeys } from "@/api/authNew";
import { useQuery } from "@tanstack/react-query";

export const passkeysQueryKeys = {
  list: "passkeys-list",
};

export function usePasskeys() {
  return useQuery({
    queryKey: [passkeysQueryKeys.list],
    queryFn: getPasskeys,
  });
}
